import React from 'react';
import './PaymentMethods.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import PaymentMethodsData from '../../Components/Admin/PaymentMethodsData/PaymentMethodsData';

export default function PaymentMethods() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection paymentMethodsContainer'>
                <HeaderDash />
                <div className='payment-methods-container-wrapper'>
                    <PaymentMethodsData />
                </div>
            </section>
        </div>
    );
}






